import firebase from "../firebase";
import { doc, getDocs, addDoc, setDoc, deleteDoc, getDoc } from "firebase/firestore";

const db = firebase.collection("users");

class UsersService {
  async get(id) {
    return (await getDoc(doc(db, id))).data();
  }

  async getRaw(id) {
    return await getDoc(doc(db, id));
  }

  async getAllRaw() {
    return await getDocs(db);
  }

  async create(value) {
    return await addDoc(db, value);
  }

  async update(id, value) {
    return await setDoc(doc(db, id), value, { merge: true });
  }

  async delete(id) {
    return await deleteDoc(doc(db, id));
  }
}

export default new UsersService();